import React, { useCallback, useContext, useMemo } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withPerfMarker } from '@bingads-webui/performance-marker-react-wrapper';
import { StepContainer } from '../step-container/step-container';
import { WIZARD_ACTIONS } from '../../goal-creation-wizard-reducer';
import { GoalCreationWizardContext } from '../../goal-creation-wizard-context';
import { TagSetupInstallManuallyStepView } from './view/tag-setup-install-manually-view';

const TagSetupInstallManuallyStepUnstyled = (props) => {
  const { permissions } = props;
  const enhancedConversions = permissions.dynamic && permissions.dynamic.EnhancedConversions;
  const wizardContext = useContext(GoalCreationWizardContext);
  const i18n = useContext(I18nContext);

  const {
    goalContext: {
      Type,
      Tag: { Id },
      GoalValueType,
      IsEnhancedConversionsEnabled,
    }, logActivity, dispatch,
  } = wizardContext;

  const nextPageHandler = useCallback(() => {
    const goToEventTagSetup = Type === 'EventGoal' || Type === 'ProductConversionGoal'
    || GoalValueType === 'VariantValue';

    if (enhancedConversions && IsEnhancedConversionsEnabled) {
      wizardContext.dispatch({
        type: WIZARD_ACTIONS.NAVIGATE_TO_SETUP_ENHANCED_CONV,
        data: {},
      });
    } else {
      wizardContext.dispatch({
        type: goToEventTagSetup ?
          WIZARD_ACTIONS.NAVIGATE_WITH_TAG_INSTALL_INSTRUCTIONS :
          WIZARD_ACTIONS.WIZARD_NAVIGATE_NEXT,
        data: {},
      });
    }
  }, [GoalValueType, IsEnhancedConversionsEnabled, Type, enhancedConversions, wizardContext]);

  const handleCancel = useCallback(() => {
    wizardContext.exitWizard();
  }, [wizardContext]);

  const footerConfig = useMemo(() => ({
    buttons: [{
      type: 'Secondary',
      onClick: wizardContext.goBack,
      isEnabled: true,
      text: i18n.getString(_TL_(('Back'))),
    },
    {
      type: 'Primary',
      onClick: nextPageHandler,
      isEnabled: true,
      text: i18n.getString(_TL_(('Next'))),
    },
    {
      type: 'Cancel',
      onClick: handleCancel,
      isEnabled: true,
      text: i18n.getString(_TL_(('Cancel'))),
    }],
  }), [wizardContext.goBack, handleCancel, nextPageHandler, i18n]);

  return (
    <StepContainer
      subContainer
      step="tag-setup-selection"
      footerConfig={footerConfig}
      title={i18n.getString(_TL_('Add the tag manually'))}
    >
      <TagSetupInstallManuallyStepView
        i18n={i18n}
        tagId={Id}
        uetTagInstructions={wizardContext.tagTemplates.UETTagInstructions}
        logActivity={logActivity}
        wizardDispatch={dispatch}
        tagTemplates={wizardContext.tagTemplates}
        permissions={permissions}
      />
    </StepContainer>

  );
};

export const TagSetupInstallManuallyStep = withPerfMarker(TagSetupInstallManuallyStepUnstyled);
